module.exports = __webpack_public_path__ + "img/car.82fece5b.svg";